import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
/**
 * The Header of the Card is displayed at the top of the Card, before content.
 * Height can have two possible values through the `small` prop.
 *
 * @return {jsx}
 */

var Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "uanikb-0"
})(["border-bottom:solid 1px ", ";display:flex;align-items:center;justify-content:space-between;height:7.4rem;padding:0 3rem;", ""], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.veryLightBlue;
}, function (_ref2) {
  var small = _ref2.small;
  return small && css(["height:6rem;padding:0 2rem;"]);
});
/**
 * PropTypes Validation
 */

var bool = PropTypes.bool;
Header.propTypes = {
  /**
   * change header size
   */
  small: bool
};
/**
 * Default props
 */

Header.defaultProps = {
  small: false
};
export default Header;